// extracted by mini-css-extract-plugin
export default {"main":"questone_main__5VCIR","box":"questone_box__C9Kab","text":"questone_text__aeK1z","menu":"questone_menu__+M7m2","icon":"questone_icon__AJ7gd"};